/**
 * Enum describing the possible positions of the stamps
 */
export enum StampPosition {
  LEFT,
  RIGHT,
}



// WEBPACK FOOTER //
// ./src/enums/StampPosition.ts